<template>
  <div class="row">
    <div class="col">
      <div class="form-group">
        <label>Left %</label>
        <input
          v-model.number="input.left"
          type="number"
          class="form-control"
          @input="onInput"
        >
      </div>
    </div>
    <div class="col">
      <div class="form-group">
        <label>Top %</label>
        <input
          v-model.number="input.top"
          type="number"
          class="form-control"
          @input="onInput"
        >
      </div>
    </div>
    <div class="col">
      <div class="form-group">
        <label for="formControlRange">Width %</label>
        <input
          v-model.number="input.right"
          type="number"
          class="form-control"
          @input="onInput"
        >
      </div>
    </div>
    <div class="col">
      <div class="form-group">
        <label for="formControlRange">Height %</label>
        <input
          v-model.number="input.bottom"
          type="number"
          class="form-control"
          @input="onInput"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { TYPE_MASK, DEFAULT_OBJECT_MASKS } from '@frontend/group/modules/mask-settings';
import { transformObjectDataToPercent, transformObjectDataToInteger } from '@frontend/group/modules/mask-settings/helpers';

export default {
  props: {
    objectData: {
        type: Object,
        default: () => transformObjectDataToPercent(
          DEFAULT_OBJECT_MASKS()[TYPE_MASK.RECTANGLE]
        )
    }
  },
  data() {
    return {
      input: {
        ...transformObjectDataToPercent(
          DEFAULT_OBJECT_MASKS()[TYPE_MASK.RECTANGLE]
        )
      }
    }
  },
  watch: {
    objectData() {
      this.input = transformObjectDataToPercent({ ...this.objectData });
    }
  },
  methods: {
    onInput() {
      this.$emit('input', {
        typeMask: TYPE_MASK.RECTANGLE,
        objectData: transformObjectDataToInteger({ ...this.input })
      });
    }
  }
}
</script>